var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._m(0),_c('div',{staticClass:"row-btn mt-4"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/login"}},[_vm._v("Go to login")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"font-italic text-center"},[_vm._v(" Instructions to reset your password will be sent to your email address. ")])])
}]

export { render, staticRenderFns }